import {Button} from "primereact/button"
import {useMutation, useQueryClient} from "react-query"
import {deleteCandidate} from "../../../networks/deleteNetwork"
import {useNavigate} from "react-router-dom"
import {ConfirmDialog} from "primereact/confirmdialog"
import {useState} from "react"
import {refreshOnCandidateListChange} from "../../../utils/RefreshFunctions"
import {analyticsEvent, AnalyticsEventCategory} from "../../../services/analytics/analytics"
import useRoleStatus from "../../../hooks/useRoleStatus"
import {UserRoles} from "../../../models/Names"

type CandidateDeleteProps = {
    id: string|undefined
}

export interface DeleteCandidateParams {
    id: string
}

const CandidateDelete = (deleteProps: CandidateDeleteProps) => {
    let navigate = useNavigate()
    const queryClient = useQueryClient()
    const roleStatus = useRoleStatus([UserRoles.AGENCY, UserRoles.ADMIN])
    const deletingMutation = useMutation<void, Error, DeleteCandidateParams>(deleteCandidate, {
        onSuccess: (data, { id }) => {
            void refreshOnCandidateListChange(queryClient)
            analyticsEvent(AnalyticsEventCategory.DELETE_CANDIDATE, {
                role: roleStatus.role,
                candidateId: deleteProps.id,
            })
        },
        onError: (error) => {
            analyticsEvent(AnalyticsEventCategory.DELETE_CANDIDATE, {
                role: roleStatus.role,
                candidateId: deleteProps.id,
                error: "Error deleting candidate"
            })
        }
    })
    const [dialogVisible, setDialogVisible] = useState(false)

    const handleDeleteCandidate = () => {
        if (deleteProps.id !== undefined){

            deletingMutation.mutate({id: deleteProps?.id})
            navigate(-1)
        }
    }
    const handleClick = () => {
        setDialogVisible(true)
    }
    return (
        <>
            <ConfirmDialog header="Confirm" visible={dialogVisible}
                           message="Are you sure you want to delete this candidate?"
                           icon="pi pi-exclamation-triangle"
                           acceptClassName="p-button-danger"
                           rejectClassName="p-button-secondary"
                           accept={() => handleDeleteCandidate()}
                           reject={() => {setDialogVisible(false)}}
                            onHide={() => {setDialogVisible(false)}} />
            <Button onClick={handleClick} className='bg-red-300 p-2 border-0' >
                <i className="pi pi-trash" style={{'fontSize': '1em'}}></i>
            </Button>
        </>
    )
}

export default CandidateDelete